import { render } from "./CustomSelect.vue?vue&type=template&id=17e4ffe8&scoped=true"
import script from "./CustomSelect.vue?vue&type=script&lang=js"
export * from "./CustomSelect.vue?vue&type=script&lang=js"

import "./CustomSelect.vue?vue&type=style&index=0&id=17e4ffe8&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e4ffe8"]])

export default __exports__